module.exports = __webpack_public_path__ + "img/arrow.down.450600a9.svg";